export default __webpack_public_path__ + "static/media/ubi3.e3698038.jpg";